<template>
    <div>
        <div class="mb-2">
            <span class="text-xl font-bold mr-2">{{ title }}</span>
            <span>({{replayData.durationSeconds}} сек.)</span>
            <span v-if="allowLoad" class="ml-6 link cursor-pointer text-blue-500" @click="loadReplayData" >загрузить</span>
        </div>
        <div class="flex flex-row">
            <div class="text-lg mr-4">
                <div class="flex flex-row mb-2">
                    <div class="w-14rem">Депозит:</div>
                    <div>${{round(replayData.maxDepositUsage, 2)}}</div>
                </div>
                <div class="flex flex-row mb-2">
                    <div class="w-14rem">Cделок:</div>
                    <div>{{replayData.countClosedDeals}}/{{replayData.countOpenDeals}}</div>
                </div>
                <div class="flex flex-row mb-2">
                    <div class="w-14rem">Касаний maxOpenDeals:</div>
                    <div>{{replayData.countReachMaxDeals}}</div>
                </div>

            </div>
            <div class="text-lg mr-4">
                <div class="flex flex-row mb-2 align-items-baseline">
                    <div class="w-14rem">Профит:
                        <span class="ml-1 text-gray-500 cursor-pointer">
                                                <i class="pi pi-question-circle"
                                                   v-tooltip.bottom="'Прибыль, которую покажет бот, запущенный с данными настройками'"></i></span>
                    </div>
                    <div v-html="round_colored(replayData.netProfitProportion*100, 2, '', '%')"></div>
                    <div class="text-sm ml-1" v-html="round_colored(replayData.netProfit, 2, '($', ')')"></div>
                </div>
                <div class="flex flex-row mb-2">
                    <div class="w-14rem">Коэффициент Шарпа:</div>
                    <div v-html="round_colored(replayData.sharpeRatio, 3, '', '')"></div>
                </div>
                <div class="flex flex-row mb-2">
                    <div class="w-14rem">Винрейт:</div>
                    <div>{{round(replayData.percentWinningDeals*100, 0)}}%</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import helperMethods from "@/helpers";
import Button from "primevue/button";
export default {
    props:{
        title: String,
        replayData: Object,
        allowLoad: Boolean,
        loadFunction: Function
    },
    components:{
        Button
    },
    data(){
        return {}
    },
    methods:{
        ...helperMethods,
        loadReplayData(){
            this.loadFunction(this.replayData);
        }
    }

}
</script>
